angular.module('satv.mediastats')
.controller('StatResultsCtrl', ['$scope', function($scope) {

    $scope.getUserDetails = function(stat) {
        return 'User ID: ' + stat.user.id;
    };

    $scope.getRequestDetails = function(stat) {
        return stat.user_agent;
    };

    $scope.getContextDetails = function(stat) {
        return stat.context.data;
    };
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediastatsclientbundle/Resources/js/angular/controllers/StatResultsCtrl.js